import { apolloProvider } from '@/modules/myStageGraphQL';
import { MYSTAGE_AUTH_TOKEN } from '@/graphql/mutations/mystageToken';
import logger from '@/modules/Logger';
import { 
  getMyStageRefreshToken,
  saveMyStageLoginCookies,
  getMyStageToken
} from '@/modules/myStageGraphQL/AuthCookieManager';
import { redirectToHome } from '@/utils/common';
import { errorCodes } from '@/utils/constants';

const nextWithoutCred = (to, from, next) => {
    const queryWithoutCred = Object.fromEntries(
      Object.entries(to.query).filter(([key]) => key !== 'cred')
    );
    next({ path: to.path, query: queryWithoutCred, replace: true });
}

const credentialRouteGuard = async (to, from, next) => {
  const legacy = to.query.legacy;
  const mystageToken = getMyStageToken();
  const refreshToken = getMyStageRefreshToken();
  const hasToken = !!mystageToken || !!refreshToken;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  // Log lessonId only for /lesson route
  const lessonId = to.path.startsWith('/lesson/') ? to.params.lessonId || '' : '';

  if (to.query.cred) {
    try {
      const client = apolloProvider.defaultClient;
      const { data } = await client.query({
        query: MYSTAGE_AUTH_TOKEN,
        fetchPolicy: 'no-cache',
        variables: {
          credential: to.query.cred,
          existingToken: refreshToken
        },
        context: {
          authRequired: false
        }
      });

      const result =  data?.createAuthToken || {};
      if (result.is_existing_valid === false) {
        saveMyStageLoginCookies(result)
      }

      nextWithoutCred(to, from, next);
    } catch (error) {
      logger.debug(`[MYSTAGE][AUTH] Token fetch failed: ${error}`, {
        operation: "mystage_auth_token",
        cred: to.query.cred,
        lessonId: lessonId
      });

      redirectToHome(errorCodes.ME005, lessonId);
    }
  // For routes that requires Authentication
  // MyStage must be accessed only by either using cred or existing tokens
  // If both are not present then redirect to error page
  } else if (requiresAuth && !legacy && !hasToken) {
    logger.debug(`[MYSTAGE][AUTH] MyStage has no cred and token detected, redirect user to home`, {
      operation: "mystage_auth_token",
      lessonId: lessonId
    });

    redirectToHome(errorCodes.ME005, lessonId);
  } else {
    next();
  }
};

export { credentialRouteGuard };
